import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './Star.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Star = function Star(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'filled' : _ref$theme,
    uniqueKey = _ref.uniqueKey,
    value = _ref.value,
    className = _ref.className,
    index = _ref.index,
    onClick = _ref.onClick,
    onMouseOver = _ref.onMouseOver;
  var gradientId = "gradient-".concat(uniqueKey, "-").concat(index);
  var strokeFill = theme === 'filled' ? "url(#".concat(gradientId, ")") : '#ff9d00';
  var offset = "".concat(value * 100, "%");
  var handleClick = function handleClick() {
    if (onClick) {
      onClick(index);
    }
  };
  var handleMouseOver = function handleMouseOver() {
    if (onMouseOver) {
      onMouseOver(index);
    }
  };
  return /*#__PURE__*/_jsx("li", {
    className: clsx(styles['container'], onClick && styles['pointer'], className),
    onClick: onClick ? handleClick : undefined,
    onMouseOver: handleMouseOver,
    children: /*#__PURE__*/_jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "100%",
      height: "100%",
      viewBox: "0 0 20 18",
      children: [/*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsxs("linearGradient", {
          id: gradientId,
          y2: "0%",
          x2: "100%",
          y1: "0%",
          x1: "0%",
          children: [/*#__PURE__*/_jsx("stop", {
            offset: "0%",
            stopOpacity: "1",
            stopColor: "#ff9d00"
          }), /*#__PURE__*/_jsx("stop", {
            offset: offset,
            stopOpacity: "1",
            stopColor: "#ff9d00"
          }), /*#__PURE__*/_jsx("stop", {
            offset: offset,
            stopOpacity: "0",
            stopColor: "#ff9d00"
          }), theme === 'filled' && /*#__PURE__*/_jsx("stop", {
            offset: offset,
            stopOpacity: "1",
            stopColor: "#c9c9c9"
          }), theme === 'filled' && /*#__PURE__*/_jsx("stop", {
            offset: "100%",
            stopOpacity: "1",
            stopColor: "#c9c9c9"
          })]
        })
      }), /*#__PURE__*/_jsx("path", {
        stroke: strokeFill,
        fill: "url(#".concat(gradientId, ")"),
        d: "M15.214 17.176l-.996-5.805 4.218-4.112-5.83-.847L10 1.13 7.393 6.412l-5.83.847 4.219 4.112-.996 5.805L10 14.436l5.214 2.74z"
      })]
    })
  });
};